/**
 * DeliverFresh - Custom JavaScript
 * Vanilla JS, no dependencies
 */

document.addEventListener('DOMContentLoaded', () => {
  /* =========================================================
   * 1. Countdown Timer
   * ========================================================= */
  const countdownBox = document.querySelector('.df-countdown-box');

  if (countdownBox) {
    const cutoffHour = parseInt(countdownBox.dataset.cutoff, 10) || 18;
    const hoursEl = document.getElementById('df-cd-h');
    const minsEl = document.getElementById('df-cd-m');
    const secsEl = document.getElementById('df-cd-s');
    const messageEl = countdownBox.querySelector('.df-countdown-message');

    const pad = (n) => String(n).padStart(2, '0');

    const getAESTComponents = () => {
      const now = new Date();
      const aestString = now.toLocaleString('en-AU', { timeZone: 'Australia/Melbourne' });
      // en-AU format: "DD/MM/YYYY, HH:MM:SS" or "D/M/YYYY, h:mm:ss am/pm"
      // Use Intl to get reliable numeric parts
      const formatter = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Melbourne',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
      });
      const parts = formatter.formatToParts(now);
      const h = parseInt(parts.find(p => p.type === 'hour').value, 10);
      const m = parseInt(parts.find(p => p.type === 'minute').value, 10);
      const s = parseInt(parts.find(p => p.type === 'second').value, 10);
      return { hours: h, minutes: m, seconds: s };
    };

    const updateCountdown = () => {
      const aest = getAESTComponents();
      const nowSeconds = aest.hours * 3600 + aest.minutes * 60 + aest.seconds;
      const cutoffSeconds = cutoffHour * 3600;

      let diff = cutoffSeconds - nowSeconds;

      if (diff <= 0) {
        // Past cutoff — count to next day's cutoff
        if (messageEl) {
          messageEl.textContent = 'Next day delivery';
        }
        diff += 24 * 3600; // add 24 hours
      } else {
        if (messageEl) {
          messageEl.textContent = '';
        }
      }

      const hours = Math.floor(diff / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const seconds = diff % 60;

      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(minutes);
      if (secsEl) secsEl.textContent = pad(seconds);
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* =========================================================
   * 2. Price Ticker Marquee
   * ========================================================= */
  const tickerTrack = document.querySelector('.df-ticker-track');

  if (tickerTrack) {
    // Clone all children for seamless infinite scroll
    const children = Array.from(tickerTrack.children);
    children.forEach((child) => {
      const clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      tickerTrack.appendChild(clone);
    });

    // Pause on hover, resume on leave
    tickerTrack.addEventListener('mouseenter', () => {
      tickerTrack.style.animationPlayState = 'paused';
    });

    tickerTrack.addEventListener('mouseleave', () => {
      tickerTrack.style.animationPlayState = 'running';
    });
  }

  /* =========================================================
   * 3. Category Strip Sticky
   * ========================================================= */
  const catStrip = document.querySelector('.df-cat-strip[data-sticky="true"]');

  if (catStrip) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        catStrip.classList.toggle('is-sticky', !entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px',
      }
    );

    // Create a sentinel element placed just above the strip
    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.left = '0';
    sentinel.style.pointerEvents = 'none';
    sentinel.setAttribute('aria-hidden', 'true');

    catStrip.style.position = 'relative';
    catStrip.prepend(sentinel);
    observer.observe(sentinel);
  }
});

